import { Center, ColorSpinner } from "@vygruppen/spor-react"

const Spinner = ({ label }: { label?: String }) => (
  <Center flexGrow={1}>
    <ColorSpinner maxWidth="58px">{label}</ColorSpinner>
  </Center>
)

export default Spinner
